import {

  LOGIN_SUCCESS,
  LOG_OUT,

  GET_ADDRESS_USER,
  UPDATE_INFO_ACCOUNT,
  UPDATE_USER_DATA,
  ActionT,
  REFRESH_TOKEN
} from '../actions/actionsType'
import config from '../../constants/config'
import { UserT, CoordinateT } from '../../types/Users'


const profileUser = {

}



export interface AuthStateT {
  userData: UserT;
  loading: boolean,
  token: string,
  refreshToken: string,
  successLogin?: boolean,
  socketToken?: string,
  unLockPageMain?: boolean,
  isCheckAuth?: boolean,
  tokenExpires?: number,
  fcmToken?: string
  isRegister?: boolean
}
const authInit: AuthStateT = {
  loading: false,
  token: null,
  refreshToken: null,
  successLogin: false,
  userData: null,
  socketToken: null,
  unLockPageMain: false,
  isCheckAuth: false,
  tokenExpires: 0,

}

export function authReducer(state: AuthStateT = authInit, action: ActionT): AuthStateT {
  switch (action.type) {
    case LOGIN_SUCCESS:
      //localStorage.setItem('token', action.payload.token);

      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
      // console.log("LOGIN_SUCCESS", action.payload)
      return {
        ...state,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        socketToken: action.payload.token,
        userData: action.payload.userData,
        tokenExpires: action.payload.tokenExpires,
        // user_meta: action.user_meta,
        // socket_token: action.socket_token ? action.socket_token : state.socket_token,
      };
    case REFRESH_TOKEN:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
      console.log("REFRESH_TOKEN", action.payload)
      return {
        ...state,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        socketToken: action.payload.token,
        tokenExpires: action.payload.tokenExpires,
      };
    case LOG_OUT:
      // localStorage.removeItem('token');
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      return {
        ...state,
        loading: false,
        token: null,
        userData: null,
        refreshToken: null,
        socketToken: null,
        tokenExpires: null,
      }

    case UPDATE_USER_DATA:
      return {
        ...state,
        userData: { ...state.userData, ...action.payload }
      }
    case UPDATE_INFO_ACCOUNT:
      return {
        ...state,
        userData: { ...state.userData, ...action.payload }
      }
    default:
      return state;
  }
}

export default authReducer;
